
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/features/springsale_2025",
      function () {
        return require("private-next-pages/features/springsale_2025.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/features/springsale_2025"])
      });
    }
  